"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchResult = exports.fetchAPI = exports.default = void 0;

var _fetch = require("@iyunbao/fetch");

var _bridge = _interopRequireDefault(require("@iyunbao/bridge"));

var _tools = require("./tools");

var _cookie = _interopRequireDefault(require("./cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 接口请求
 */
var fetchAPI = new _fetch.FetchAPI();
exports.fetchAPI = fetchAPI;
var _tempFetch = fetchAPI.fetch; // 添加app版本

fetchAPI.fetch = function (data) {
  var path = data.path || '';
  var urlParams = {
    _version: _bridge.default.app_version(),
    _client: _tools.isIOS ? 1 : 2,
    // 用于订单记录统计
    __MYLOG_UID: _cookie.default.get('__MYLOG_UID') || '',
    __MYLOG_SID: _cookie.default.get('__MYLOG_SID') || '',
    _browser: (0, _tools.parserBrowser)()
  };
  var query = Object.keys(urlParams).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(urlParams[key]));
  }).join('&');
  path += !~path.indexOf('?') ? '?' : '&';
  data.path = path + query;
  return _tempFetch.call(fetch, data);
};

/**
 * 接口请求报文结果
 * @param data
 */
var getFetchResult = function getFetchResult(data) {
  if (data && (0, _tools.isObject)(data.content)) {
    return data.content;
  }

  if (data && (0, _tools.isObject)(data.result)) {
    return data.result;
  }
};

exports.getFetchResult = getFetchResult;
var _default = fetchAPI;
exports.default = _default;